<section class="home-hero">
  <app-background-animation></app-background-animation>
  <div class="home-hero-content">
    <app-slider-home></app-slider-home>
  </div>
</section>

@defer (on idle) {
  <section class="home-pricing container-page">
    <div id="tariffs"></div>
    <app-list-prices [currencyEUR]="currencyEUR"></app-list-prices>
  </section>

  <section class="home-compare container-page-md">
    <app-table-tarif></app-table-tarif>
  </section>
}

<app-partners></app-partners>
<app-contact></app-contact>
